<template>
  <v-lazy
      :min-height="555"
      :options="{ threshold: 0.5 }"
      transition="fade"
  >
    <div :class="{'tcdc-article-card-border-green': border }">
      <v-row>
        <v-col>
          <v-img :src="image" :alt="title" aspect-ratio="1.7">
            <template v-slot:placeholder>
              <v-sheet color="#EFEFEF" class="fill-height"></v-sheet>
            </template>
          </v-img>
          <p class="sub-header1 text-tcdc-green mt-6 bold">{{title}}</p>
          <div class="text-tcdc-grey1 three-line">
            {{description}}
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="color-grey1 text-tcdc-grey1 bold mr-4">{{date | moment('DD MMM YYYY')}}</span>
          <img alt="tcdc" src="../../assets/icons/generals/view.png" class="tcdc-view-icon mr-2" />
          <span class="color-grey1 text-tcdc-grey1 bold">{{formatNumber(viewer)}}</span>
        </v-col>
      </v-row>
    </div>
  </v-lazy>
</template>

<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    date: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    viewer: {
      type: Number,
      default: null
    }
  },
  methods: {
    formatNumber(num) {
      if(num){
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-article-card-border-green {
  border-bottom: 2px solid $tcdcGreen;
}
  .three-line {
    height: 81px;
    line-height: 1.7rem;
    overflow: hidden;
    /*-webkit-line-clamp: 3;*/
    -webkit-box-orient: vertical;
    display: block;
    display: -webkit-box;
    word-break: break-word;
  }
</style>
